import { render, staticRenderFns } from "./SnackbarComponent.vue?vue&type=template&id=89556862&"
import script from "./SnackbarComponent.vue?vue&type=script&lang=js&"
export * from "./SnackbarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports